import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext, useReducer, useContext } from "react";
import { isEmpty } from "lodash";
/**
 * Internal logic and state management
 *
 *    dictionary is:
 *        key: search-term (some fuzzy or exact string)
 *        val: list of ids (unique id to get corresponding entity / table-data-row, often a highlight-entity-id)
 */
const emptyData = {
    tableSearchTerms: {},
    timestamp: 0,
};
const initialState = emptyData;
function reducer(state, action) {
    let tableSearchTerms = {};
    let tst = {};
    switch (action.type) {
        case "REMOVE_ALL":
            tableSearchTerms = state.tableSearchTerms;
            delete tableSearchTerms[action.payload.tableName];
            return { tableSearchTerms, timestamp: Date.now() };
        case "REMOVE_TERM":
            tableSearchTerms = state.tableSearchTerms;
            tst = tableSearchTerms[action.payload.tableName];
            if (isEmpty(tst)) {
                tst = {};
            }
            delete tst[action.payload.searchTerm];
            tableSearchTerms[action.payload.tableName] = tst;
            return { tableSearchTerms, timestamp: Date.now() };
        case "ADD_TERM":
            tableSearchTerms = state.tableSearchTerms;
            tst = tableSearchTerms[action.payload.tableName];
            if (isEmpty(tst)) {
                tst = {};
            }
            tst[action.payload.searchTerm] = action.payload.matchedEntityIds;
            tableSearchTerms[action.payload.tableName] = tst;
            return { tableSearchTerms, timestamp: Date.now() };
        case "SWAP_TERM":
            tableSearchTerms = state.tableSearchTerms;
            tst = tableSearchTerms[action.payload.tableName];
            if (isEmpty(tst)) {
                tst = {};
            }
            tst[action.payload.searchTerm] = action.payload.matchedEntityIds;
            delete tst[action.payload.remove];
            tableSearchTerms[action.payload.tableName] = tst;
            return { tableSearchTerms, timestamp: Date.now() };
        default:
            throw new Error("unknown reducer-action type");
    }
}
/**
 * Exported context and provider hooks
 */
const ctx = createContext({
    state: initialState,
    dispatch: () => null,
});
function ContextProvider(props) {
    const [state, dispatch] = useReducer(reducer, initialState);
    return _jsx(ctx.Provider, { value: { state, dispatch }, ...props });
}
function useFuzzySearchTerms() {
    const context = useContext(ctx);
    if (context === undefined) {
        throw new Error(`No provider for FuzzySearchTermsContext given`);
    }
    return {
        ...context,
    };
}
export { ContextProvider, useFuzzySearchTerms };
